import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { formatImportMoney, formatMarkupPercent } from '../manualImportMeta';
import type { ManualImportForm } from '../useManualImport';
import { SummaryTile } from './SummaryTile';

type SummaryPanelProps = {
    form: ManualImportForm;
};

/** Live products-total / expenses / cost / markup figures. */
export const SummaryPanel: React.FC<SummaryPanelProps> = ({ form }) => {
    const { t } = useTranslation('pages');
    const { summary } = form;

    return (
        <section {...getNodeTestIdProp('manual-import-summary')}>
            <Card {...getNodeTestIdProp('manual-import-summary-card')}>
                <Card.Content
                    className="grid grid-cols-2 gap-4 lg:grid-cols-4"
                    {...getNodeTestIdProp('manual-import-summary-content')}
                >
                    <SummaryTile
                        label={t(
                            'purchases.manualImport.summary.productsTotal',
                        )}
                        slot="products-total"
                        value={formatImportMoney(summary.productsTotal)}
                    />
                    <SummaryTile
                        label={t(
                            'purchases.manualImport.summary.extraExpenses',
                        )}
                        slot="extra-expenses"
                        value={formatImportMoney(summary.extraExpenses)}
                    />
                    <SummaryTile
                        label={t('purchases.manualImport.summary.totalCost')}
                        slot="total-cost"
                        value={formatImportMoney(summary.totalCost)}
                    />
                    <SummaryTile
                        label={t('purchases.manualImport.summary.markup')}
                        slot="markup"
                        value={
                            summary.markupPercent === null
                                ? '—'
                                : formatMarkupPercent(summary.markupPercent)
                        }
                    />
                </Card.Content>
            </Card>
        </section>
    );
};
